const ITEMS = ["Mira el video", "Agenda tu consultoría", "Empieza a generar", "Vende online desde casa"];

function Row() {
    return (
        <div className="flex shrink-0 items-center">
            {ITEMS.map((item, i) => (
                <span key={item} className="flex items-center">
                    <span
                        className={
                            i % 2 === 0
                                ? "font-display text-sm font-bold uppercase tracking-[0.22em] text-[#666]"
                                : "serif-accent text-lg text-[#ff7a30]"
                        }
                    >
                        {item}
                    </span>
                    <span className="mx-8 h-1.5 w-1.5 rounded-full bg-[#ff5c00]/70" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="overflow-hidden border-y border-[#1c1c1c] py-4" data-testid="marquee" aria-hidden="true">
            <div className="marquee-track">
                <Row />
                <Row />
                <Row />
                <Row />
            </div>
        </div>
    );
}
